/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/Product/ProductAddToCart',[
    'jquery',
    'global/all',
    'modules/Cart/all',
    'modules/Favorites/FavoritesManager',
    'modules/Delivery/DeliveryOptions',
    'modules/GiftCards/GiftCards',
    './ProductAddToCart.Forms'
], function ($, Roc, Cart, FavoritesManager, DeliveryOptions, GiftCards, Forms) {
    'use strict';

    var apiUrl = window.RocConfig.api.baseRocApiUrl;
    var btns = {
        addToCart: '[data-roc-action="addToCart"]',
        addToCartBySku: '[data-roc-action="addToCartBySku"]',
        favoritesAddItem: '[data-roc-action="favoritesAddItem"]',
        favoritesAddToCart: '[data-roc-action="favoritesAddToCart"]',
        favoritesCreateList: '[data-roc-action="favoritesCreateList"]',
        addInventoryNotification: '[data-roc-action="addInventoryNotification"]',
        removeInventoryNotification: '[data-roc-action="removeInventoryNotification"]',
        reloadOutOfStock: '[data-roc-action="reloadOutOfStock"]'
    };

    function inventoryWrapper() {
        return $('[data-roc-wrapper="product-inventory"]');
    }

    function giftCardWrapper() {
        return $('[data-roc-wrapper="product-gift-card"]');
    }

    function getProductId() {
        return $('#hdnProductId').val();
    }

    function getProductSku() {
        return $('#hdnPartNumber').val();
    }

    function getGroupId() {
        return $('#hdnGroupId').val();
    }

    function getOrderItemId() {
        return $('#hdnOrderItemId').val();
    }

    function getValidatedRequestData(srcButton, qtySelector, quickViewAction) {
        var wantsQty = null;
        var isSingleProductMode = false;

        // setting value from main quantity input
        var $qty = $(qtySelector);
        if ($qty.length > 0) {
            wantsQty = $qty.val();
        }

        var dataProductId = $(srcButton).attr('data-product-id');
        var qtyCtrl = $('[data-roc-input="purchaseQuantitySimple"][data-product-id="' + dataProductId + '"]');

        if (qtyCtrl.length > 0) {
            wantsQty = qtyCtrl.val();
            isSingleProductMode = true;
        }
        
        var qty = (!wantsQty || isNaN(wantsQty)) ? -1 : parseInt(wantsQty);

        if (isNaN(qty) || qty <= 0) {
            throw {
                msg: 'There looks to be a problem with your you current quantity. Please be sure to enter the correct quantity value and try again.'
            };
        } else {
            var productId = isSingleProductMode ? dataProductId : getProductId();
            if (!productId) {
                var msg = '';
                if (quickViewAction === undefined || quickViewAction !== Roc.Enums.quickViewAction.EDIT) {
                    msg = 'We had trouble adding the item to your cart. ';
                }

                msg += 'Please make sure all options are properly selected before trying again.';

                throw {
                    msg: msg,
                    title: 'Oh no!'
                };
            }

            var request = {
                'productId': productId,
                'quantity': qty,
                'orderId': '{orderId}'
            };

            var groupId = getGroupId();
            if (groupId) {
                request.groupId = groupId;
            } else {
                request.groupId = null;
            }

            return request;
        }
    }



    function getValidatedRequestDataBySku(srcButton, qtySelector, quickViewAction) {
        var wantsQty = null;
        var isSingleProductMode = false;
       
        // setting value from main quantity input
        var $qty = $(qtySelector);
        if ($qty.length > 0) {
            wantsQty = $qty.val();
        }

        var dataProductSku = $(srcButton).attr('data-product-id');
        var qtyCtrl = $('[data-roc-input="purchaseQuantitySimple"][data-product-id="' + dataProductSku + '"]');

        if (qtyCtrl.length > 0) {
            wantsQty = qtyCtrl.val();
            isSingleProductMode = true;
        }

        var qty = (!wantsQty || isNaN(wantsQty)) ? -1 : parseInt(wantsQty);
         
        if (isNaN(qty) || qty <= 0) {
            throw {
                msg: 'There looks to be a problem with your you current quantity. Please be sure to enter the correct quantity value and try again.'
            };
        } else {
            var productSku = isSingleProductMode ? dataProductSku : getProductSku();
            if (!productSku) {
                var msg = '';
                if (quickViewAction === undefined || quickViewAction !== Roc.Enums.quickViewAction.EDIT) {
                    msg = 'We had trouble adding the item to your cart. ';
                }

                msg += 'Please make sure all options are properly selected before trying again.';

                throw {
                    msg: msg,
                    title: 'Oh no!'
                };
            }

            var request = {
                'productSku': productSku,
                'quantity': qty,
                'orderId': '{orderId}'
            };

            var groupId = getGroupId();
            if (groupId) {
                request.groupId = groupId;
            } else {
                request.groupId = null;
            }

            return request;
        }
    }


    function addToCartBySku(event) {
        
        Roc.Logger.debug('Adding to Cart...');
        var btnAddToCartBySku = event.target;
        try {
            var request = getValidatedRequestDataBySku(btnAddToCartBySku, 'input#hdnPartQuantity');
            var deliveryOptions = null;
            var giftCartData = null;

            

            Roc.Core.lockButton(btnAddToCartBySku);
            Cart.CartManager.addCartItemBySku(request.productSku, request.quantity, request.groupId, getOrderItemId(), deliveryOptions, giftCartData);

        } catch (error) {
            Roc.Logger.debug('Error adding to cart');
            Roc.Logger.debug(error);

            if (event && ($(event.currentTarget).closest('.mfp-container').length !== 0)) {
                Roc.UI.template('errorBox-Tmp', error).then(function (renderedTemplate) {
                    var modalInstance = $.magnificPopup.instance;

                    $(modalInstance.content).find('.modal-body').prepend(renderedTemplate);
                });
            } else {
                Roc.UI.displayErrorPopup(error.msg, error.title);
            };
        }
        return;
    }


    function addToCart(event) {
        Roc.Logger.debug('Adding to Cart...');
        var btnAddToCart = event.target;

        try {
            var request = getValidatedRequestData(btnAddToCart, 'input#purchaseQuantity');
            var deliveryOptions = DeliveryOptions.getProductDeliveryOptions(request.productId);
            var giftCartData = null;

            if ($('[data-roc-wrapper=product-gift-certificate-' + request.productId + ']').length > 0) {
                var isValid = Roc.Validation.validateForm(GiftCards.forms.CertificateDetails);
                if (isValid) {
                    giftCartData = Roc.Validation.getFieldValues(GiftCards.forms.CertificateDetails);
                } else {
                    return;
                }
            }

            Roc.Core.lockButton(btnAddToCart);
            Cart.CartManager.addCartItem(request.productId, request.quantity, request.groupId, getOrderItemId(), deliveryOptions, giftCartData);

        } catch (error) {
            Roc.Logger.debug('Error adding to cart');
            Roc.Logger.debug(error);

            if (event && ($(event.currentTarget).closest('.mfp-container').length !== 0)) {
                Roc.UI.template('errorBox-Tmp', error).then(function (renderedTemplate) {
                    var modalInstance = $.magnificPopup.instance;

                    $(modalInstance.content).find('.modal-body').prepend(renderedTemplate);
                });
            } else {
                Roc.UI.displayErrorPopup(error.msg, error.title);
            };
        }
        return;
    }

    function itemAddedToCartEvt(data) {
        Roc.Core.releaseLockedButton(btns.addToCart);
        Roc.Core.releaseLockedButton(btns.addToCartBySku);
        if (!data.success) {
            var model = data || {};

            model.templ = 'addToCart';
            model.heading = data.message || 'An error occurred while trying to add the item to your cart.';

            Roc.UI.template('serviceErrors-Tmp', model).then(function (renderedTemplate) {
                Roc.UI.displayErrorPopup(renderedTemplate);
            });

            return;
        }
    }

    function addToCartEvt() {
        Roc.UI.siteBody
            .off('click', btns.addToCart)
            .on('click', btns.addToCart, function (e) {
                e.preventDefault();
                addToCart(e);
            });


        Roc.UI.siteBody
            .off('click', btns.addToCartBySku)
            .on('click', btns.addToCartBySku, function (e) {
                e.preventDefault();
                addToCartBySku(e);
            });

        Roc.UI.siteBody
            .off('keypress', 'input#purchaseQuantity')
            .on('keypress', 'input#purchaseQuantity', function (e) {
                if (e.which === 13) {
                    e.preventDefault();
                    $(btns.addToCart).trigger('click');
                };
            });
    }

    function addToFavoritesEvt() {
        Roc.UI.siteBody
            .off('click', btns.favoritesAddItem)
            .on('click', btns.favoritesAddItem, function () {
                var listId = $(this).attr('data-listid');
                var productId = getProductId(); // get product id for current selections (if applicable)

                if (!productId) {
                    productId = $(this).attr('data-product-id');
                }

                FavoritesManager.addItem(productId, listId, 1, getGroupId());
                Roc.UI.block();
            });
    }

    function addToFavoritesWithRedirectEvt() {
        Roc.UI.siteBody
            .off('click', btns.favoritesAddToCart)
            .on('click', btns.favoritesAddToCart, function () {
                var redirectUrl = $(this).attr('data-redirect-url');
                window.location.href = redirectUrl;
            });
    }

    function createFavoritesListAndAddItemEvt() {
        Roc.UI.siteBody
            .off('click', btns.favoritesCreateList)
            .on('click', btns.favoritesCreateList, function () {
                FavoritesManager.addListAndMoveItem(getProductId());
            });
    }

    function favoritesListAdded(data) {
        if (data.Result === true && data.id) {
            $('.roc-addToCartFavoritesMenu ul').each(function () {
                $(this).prepend('<li><button class="btn btnText" data-roc-action="favoritesAddItem" data-listid="' + data.id + '">' + data.name + '</button></li>');
            });
        }
    }

    function itemFavorited(data) {
        Roc.UI.unblock();
    }

    function reloadOutOfStockTempl(data) {
        Roc.UI.template('productInventoryActionOutOfStock-Tmp', data).then(function (renderedTemplate) {
            inventoryWrapper().html(renderedTemplate);
        });
    }

    function addInventoryNotificationEvt() {
        $(document)
            .off('click', btns.addInventoryNotification)
            .on('click', btns.addInventoryNotification, function () {

                if (!Roc.Validation.validateForm(Forms.addInventoryNotificationForm, true, false)) {
                    return false;
                }
                var data = Roc.Forms.getFormValues(Forms.addInventoryNotificationForm);
                data.productId = $(this).attr('data-product-id');

                if (data.productId && data.email) {
                    Roc.UI.block();
                    Roc.Core.lockButton(btns.addInventoryNotification);
                    $.ajax({
                        url: apiUrl + '/api/inventory/notification/subscribe/',
                        type: 'POST',
                        dataType: 'json',
                        data: JSON.stringify(data),
                        contentType: 'application/json',
                        complete: function (xhr) {
                            Roc.Logger.info('ProductAddToCart -> addInventoryNotificationEvt');
                            Roc.Logger.info(xhr);
                            if (xhr.status === 200) {
                                data.tmpl = 'addInventoryNotificationSuccess';
                                reloadOutOfStockTempl(data);
                            } else {
                                if (xhr.status === 400) {
                                    data.tmpl = 'emailAlreadySubmitted';
                                    reloadOutOfStockTempl(data);
                                } else {
                                    Roc.UI.ajaxErrorPopup(xhr);
                                }
                            }
                            Roc.Core.releaseLockedButton(btns.addInventoryNotification);
                            Roc.UI.unblock();
                        }
                    });
                }

            });
    }

    function removeInventoryNotificationEvt() {
        $(document)
            .off('click', btns.removeInventoryNotification)
            .on('click', btns.removeInventoryNotification, function () {
                var data = {
                    email: $(this).attr('data-email'),
                    productId: $(this).attr('data-product-id')
                };

                $.ajax({
                    url: apiUrl + '/api/inventory/notification/un-subscribe/',
                    type: 'POST',
                    dataType: 'json',
                    data: JSON.stringify(data),
                    contentType: 'application/json',
                    complete: function (xhr) {
                        Roc.Logger.info('ProductAddToCart -> removeInventoryNotificationEvt');
                        Roc.Logger.info(xhr);
                        if (xhr.status === 200) {
                            data.tmpl = 'removeInventoryNotification';
                            reloadOutOfStockTempl(data);
                        } else {
                            Roc.UI.ajaxErrorPopup(xhr);
                        }
                    }
                });
                return false;
            });
    }

    function reloadOutOfStockEvt() {
        $(document).on('click', btns.reloadOutOfStock, function () {
            var data = {
                email: $(this).attr('data-email'),
                productId: $(this).attr('data-product-id')
            };
            reloadOutOfStockTempl(data);
            return false;
        });
    }

    function updateInventoryWrapper(productId, htmlContent) {
        inventoryWrapper(productId).html(htmlContent);
    }

    function updateAddToCartBtnVisibility(show) {
        var qtySel = '[data-roc-wrapper="product-quantity"]';
        if (show) {
            $(qtySel).show();
            $(btns.addToCart).show();
        } else {
            $(qtySel).hide();
            $(btns.addToCart).hide();
        }
    }
    function reloadInventoryAction(viewModel) {
        // if MS2/ISP is turned on then inventory information is displayed next to each option
        if (DeliveryOptions.isAnyDeliveryOptionAvailable()) {
            return;
        }

        var html = '';
        if (viewModel.productType === Roc.Enums.productType.Simple && viewModel.fulfillmentInventory) {
            Roc.UI.template('productInventoryAction-Tmp', viewModel.fulfillmentInventory).then(function (renderedTemplate) {
                html = renderedTemplate;
                updateInventoryWrapper(viewModel.productId, renderedTemplate);
            });
        } else {
            updateInventoryWrapper(viewModel.ProductId, html);
        }
        updateAddToCartBtnVisibility(viewModel.canAddProduct);
    }

    function reloadGiftCardForm(viewModel) {
        if (viewModel.productType === Roc.Enums.productType.GiftCard && viewModel.isVirtualItem) {
            Roc.UI.template('giftCardForm-Tmp', { productId: viewModel.id }).then(function (renderedTemplate) {
                giftCardWrapper().html(renderedTemplate);
            });
        } else {
            giftCardWrapper().html('');
        }
    }

    function handleEnterKeyPressEvt() {
        Roc.Core.handleEnter('#txtEmailMe', function (e) {
            e.preventDefault();
            $(btns.addInventoryNotification).trigger('click');
            return false;
        });
    }

    function bindEvents() {
        if (bindEvents.COMPLETED) {
            return;
        }

        addToCartEvt();
        addToFavoritesEvt();
        createFavoritesListAndAddItemEvt();
        addToFavoritesWithRedirectEvt();
        addInventoryNotificationEvt();
        removeInventoryNotificationEvt();
        reloadOutOfStockEvt();
        handleEnterKeyPressEvt();
        Roc.EventManager.bind(Roc.Events.cart.ADD_ITEM, itemAddedToCartEvt);
        Roc.EventManager.bind(Roc.Events.favorites.ADD_LIST, favoritesListAdded);
        Roc.EventManager.bind(Roc.Events.favorites.ADD_ITEM, itemFavorited);
        Roc.EventManager.bind(Roc.Events.products.SELECTIONS_UPDATE, reloadInventoryAction);
        Roc.EventManager.bind(Roc.Events.products.SELECTIONS_UPDATE, reloadGiftCardForm);
        bindEvents.COMPLETED = true;
    }

    function init() {
        bindEvents();
        DeliveryOptions.setAddToCartButtonVisibilityCallback(updateAddToCartBtnVisibility);
    };

    function initForQuickView() {
        addToCartEvt();
        addInventoryNotificationEvt();
        removeInventoryNotificationEvt();
        reloadOutOfStockEvt();
        Roc.EventManager.bind(Roc.Events.cart.ADD_ITEM, itemAddedToCartEvt);
    }

    var ProductAddToCart = {
        init: init,
        initForQuickView: initForQuickView,
        getValidatedRequestData: getValidatedRequestData
    };

    Roc.Logger.debug('ProductAddToCart.js Loaded:', ProductAddToCart);

    return ProductAddToCart;
});
